function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Capitan embed-video.js v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.brandung.de/
 *
 *
 * Date: 2018-09-06
 * MIT License (MIT)
 */
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
import { refreshAccordeonSize } from '../reveal/reveal';
var _ = {
  defaults: {
    componentSelector: '.has-iframe'
  }
};
var o = _.defaults;

var initPlugin = function initPlugin(component) {
  var src = component.getAttribute('href');
  component.setAttribute('href', '');
  component.setAttribute('data-href', src);
  component.addEventListener('click', clickHandler);
};

var clickHandler = function clickHandler(e) {
  e.preventDefault();
  var disabled = e.target.getAttribute('disabled');

  if (!disabled) {
    e.target.setAttribute('disabled', true);
    var parent = e.target.closest('div[class^="col-"]') || e.target.closest('.row');
    appendFrame(parent, e.target.dataset.href);
  }
};

var appendFrame = function appendFrame(appendAfter, src) {
  var iframeParent = document.createElement('div');
  iframeParent.classList.add('col-xs-12');
  var iframe = document.createElement('iframe');
  iframe.classList.add('col-xs-12', 'embed-iframe');
  iframe.src = src;
  iframe.frameBorder = 0;
  iframe.style.opacity = 0; // iframe.style.minHeight = 0;

  iframeParent.appendChild(iframe);
  appendAfter.after(iframeParent);
  bindFrameEvents(iframe);
};

var bindFrameEvents = function bindFrameEvents(iframe) {
  iframe.addEventListener('load', function () {
    resizeFrame(iframe);
    CapSmartResize(function () {
      resizeFrame(iframe);
    });
  });
};

var resizeFrame = function resizeFrame(iframe) {
  // iframe.style.minHeight = `1155px`;
  iframe.style.opacity = 1;
  setTimeout(function () {
    refreshAccordeonSize();
  }, 1000); // const doc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document;
  // const body = doc.body, html = doc.documentElement;
  // const height = Math.max(body.scrollHeight, body.offsetHeight,
  //   html.clientHeight, html.scrollHeight, html.offsetHeight);
  // iframe.style.height = `${height}px`;
  // refreshAccordeonSize();
};

export function init() {
  var components = _toConsumableArray(document.querySelectorAll(o.componentSelector));

  components.forEach(function (component) {
    initPlugin(component);
  });
}